import { useQuery } from '@tanstack/react-query';
import { AES, enc } from 'crypto-js';

import { agent } from 'api/agent';
import { queryClient } from 'utils/queryClient';
import SecureStorage from 'utils/localStorage';

export const userKey = ['user'];

const useUser = () => useQuery({
  queryKey: userKey,
  queryFn: (params) => {
    const isOffline = localStorage.getItem('netStatus') === 'offline';

    if (!isOffline) {
      return agent.getClient(false)('/auth/me').then((response) => response.data);
    } else {
      let user = queryClient.getQueryData(params.queryKey);

      if (!user) {
        const userDataHash = SecureStorage.getItemSync('userData');

        const bytes = AES.decrypt(userDataHash || '', import.meta.env.VITE_APP_USER_DATA_SECRET);

        const decrypted = bytes.toString(enc.Utf8);
        user = JSON.parse(decrypted || '{}');
      }

      return user as any;
    }
  },
  retry: (_count, err) => err?.message !== 'Unauthorized',
});

export default useUser;
